import { SecureStorage } from '@aparajita/capacitor-secure-storage'
import { Capacitor } from '@capacitor/core'
import { LocalStorageRefreshTokenStore, NATIVE_REFRESH_TOKEN_KEY } from '@volee/auth'
import type { RefreshTokenStore } from '@volee/auth'

// Where the refresh token lives on this platform: the Keychain on iOS, the Keystore on
// Android — what RFC 8252 asks of a native app. The web half stays @volee/auth's.

// The plugin's key prefix stays at its default: since 8.0.1 a blank one throws, because it
// would clear every secure item the app owns, other plugins' included.
class SecureRefreshTokenStore implements RefreshTokenStore {
  async read(): Promise<string | null> {
    // The declared type is `string | null`, but a bridge that hands back `undefined` for a
    // missing key must not read as "has a stored token" (kernel.ts's `!== null` check).
    return (await SecureStorage.getItem(NATIVE_REFRESH_TOKEN_KEY)) ?? null
  }

  write(token: string): Promise<void> {
    return SecureStorage.setItem(NATIVE_REFRESH_TOKEN_KEY, token)
  }

  async clear(): Promise<void> {
    // `remove` answers false for a key that was not there; only an OS failure throws.
    await SecureStorage.remove(NATIVE_REFRESH_TOKEN_KEY)
  }
}

export function refreshTokenStoreFor(native: boolean): RefreshTokenStore {
  return native ? new SecureRefreshTokenStore() : new LocalStorageRefreshTokenStore()
}

export function platformRefreshTokenStore(): RefreshTokenStore {
  return refreshTokenStoreFor(Capacitor.isNativePlatform())
}
